/**
 * Created by Jason on 2017-4-5.
 */
import util from './util';


let download = {
    //绑定下载、预览、播放等事件
    addListener(el) {
        $(el).eq(0).on('click', (e) => {
            let $t = $(e.target);
            let fileId = $t.data('file-id');
            if (fileId) {
                downloadAction(fileId, $t);
                e.stopPropagation();
                e.preventDefault();
            }
        })
    },
    //停止播放
    stopAudio() {
        if (audio) {
            audio.pause();
        }
    },
    //获取下载地址
    getDownloadUrl(fileId, cb, type, idField) {
        let params = {
            type: type || ''
        }
        params[idField || 'fileId'] = fileId;
        $.post(SERVER + '/download/getGenerateFile', params, (json) => {
            if (json.status === 0) {
                let url = SERVER + '/download/downloadFile?downloadId=' + json.data.downloadId +
                    (type === 'onekey' ? '&downloadType=onekey' : '');
                cb(url);
            }
        })
    },

    renderList(attachmentFiles, onKeyType, onKeyId) {
        //渲染列表
        let html = '<ul class="attachment">';
        attachmentFiles.forEach((file) => {
            html += `<li>${util.getFileIcon(file.fileType)}`
            switch (file.fileType) {
                case 'silk':
                    html += `<i class="play-i fa fa-play"></i><em><a href="javascript:;" class="play fa fa-play" data-type="play" data-file-type="silk"
 data-file-id="${file.fileUuid}"> 播放</a>
                        <a class="stop" class="fa fa-download" href="javascript:;" data-type="stop" data-file-id="${file.fileUuid}"> 停止</a></em>
                        <span>语音(${Math.round(file.fileSize / 1950)}\")</span>`
                    //播放
                    break;
                case 'mp3':
                    html += `<i class="play-i fa fa-play"></i><em><a href="javascript:;" class="play fa fa-play" data-type="play" data-file-type="mp3" data-file-id="${file.fileUuid}"> 播放</a>
                        <a href="javascript:;" class="stop fa fa-stop" data-type="stop" data-file-id="${file.fileUuid}"> 停止</a><a href="javascript:;" 
                        data-type="download" class="fa fa-download" data-file-id="${file.fileUuid}"> 下载</a></em>
                        <span>${file.fileName}</span>`
                    //播放
                    break;
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'bmp':
                case 'gif':
                    html += `<em><a href="javascript:;" class="fa fa-eye" data-type="preview" data-file-type="img" data-file-id="${file.fileUuid}"> 预览</a>
                    <a href="javascript:;" class="fa fa-download" data-type="download" data-file-id="${file.fileUuid}"> 下载</a></em>
                        <span>${file.fileName}</span>`
                    //预览
                    break;
                default:
                    if (util.isOffice(file.fileType)) {
                        //预览
                        html += `<em><a href="javascript:;" class="fa fa-eye" data-type="preview" data-file-type="office" data-file-id="${file.fileUuid}"> 预览</a>
                    <a href="javascript:;" class="fa fa-download" data-type="download" data-file-id="${file.fileUuid}"> 下载</a></em>
                        <span>${file.fileName}</span>`;
                    } else {
                        //只有下载
                        html += `<em><a href="javascript:;" class="fa fa-download" data-type="download" data-file-id="${file.fileUuid}"> 下载</a></em>
                        <span>${file.fileName}</span>`;
                    }
            }

            html += '</li>'

        });

        if (attachmentFiles.length > 1 && onKeyType) {
            html += `<li class="onkey">
            <a href="javascript:;" class="btn btn-default" data-type="one-key" data-one-key-type="${onKeyType}" 
data-file-id="${onKeyId}">打包下载</a>`;
        }
        return html + '</ul>';
    },

    isPlaying() {
        return !!$playingTarget;
    }
};

let $playingTarget = null;
function downloadAction(fileId, $target){
    let fileType = $target.data('file-type');
    let type = $target.data('type');
    let $li = $target.closest('li');

    switch (type) {
        case 'play':
            $playingTarget && $playingTarget.removeClass('playing');
            download.getDownloadUrl(fileId, (url)=> {
                //停止正在播放的语音
                $playingTarget = $li.addClass('playing');
                let audio = audioFactory();
                audio.src = url;
                audio.play();
            }, 'play');
            break;
        case 'stop':
            //停止正在播放的语音
            $playingTarget.removeClass('playing');
            let audio = audioFactory();
            audio.pause();
            $playingTarget = null;
            break;
        case 'preview':
            if(fileType === 'office') {
                window.open('/office-preview.html?' + fileId);
                return;
            } else if(fileType === 'img') {
                window.open('/img-preview.html?' + fileId);
            }
            break;
        case 'download':
            download.getDownloadUrl(fileId, (url)=> {
                window.location.href = url;
            });
            break;
        case 'one-key':
            let onKeyType = $target.data('one-key-type');
            download.getDownloadUrl(fileId, (url)=> {
                window.location.href = url;
            }, 'onekey', onKeyType + 'Id');
    }

}



let audio;
function audioFactory () {
    if (!audio) {
        audio = new Audio();
        audio.onended = function () {
            if ($playingTarget) {
                $playingTarget.removeClass('playing');
                $playingTarget = null;
            }
        }
    }
    return audio;
}

module.exports = download;



// WEBPACK FOOTER //
// ./src/assets/js/download.js